import { MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react';
import { getDeviceOnlineStatusInfo } from '../../../apiclients/streamsapi_bridge';
import { customSearch, useAutoFocusSearchAfterLoads } from '../../CustomSearchUtil/CustomSearch';
import UIConstant from '../../../apiclients/UIConstant';

function LocDevices(props) {
    const [devicesList, setDevicesList] = useState([]);
    const [isloading, setIsloading] = useState(false);

    const [searchValue, setsearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);

    useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,props.isActive)
    useEffect(() => {
        if (props.locDevicesList && props.locDevicesList.length > 0) {
            // setDevicesList(props.locDevicesList);
            let proccessdRows = [];
            props.locDevicesList && props.locDevicesList.map((device) => {

                proccessdRows.push({
                    deviceObj: device,
                    phone_name: device.phone_name,
                    user: device.user,
                    extension: device.extension,
                    designation: device.designation,
                    model: device.model,
                    mac_address: device.mac_address,
                    online: (
                        <>
                            <span className="red-dot"></span>
                        </>
                    ),

                });
            });
            setDevicesList(proccessdRows);
            setFilteredRows(proccessdRows);
           
            let macAddresses = props.locDevicesList.map((obj) => obj.mac_address);
            console.log("macAddresses :: ", macAddresses);
            var paramsJo = {
                macAddresList: macAddresses,
            };

            console.log("praramJO:::::::::" + JSON.stringify(paramsJo));

            getforOnlineStatus(paramsJo, proccessdRows);



        }
      setDataLoaded(true)
    }, [props.locDevicesList,props.isActive]);

    async function getforOnlineStatus(paramsJo, proccessdRows) {
        setIsloading(true);
        let api_response = await getDeviceOnlineStatusInfo(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            paramsJo
        );
        setIsloading(false);
        console.log("api_response ::: " + api_response);
        if (!api_response.ok) {
            // console.log("Server response was not ok");
            // throw new Error("Network response was not ok");
        }
        let response = await api_response.json();
        console.log("api_response  " + response);
        var livedataObjectsInfo = response?.deviceStatus;
        console.log(
            "devicesStatus :::::: " + JSON.stringify(livedataObjectsInfo)
        );
        console.log(JSON.stringify(proccessdRows));
        let configured_devices_withstatus = [];
        for (const data of proccessdRows) {
            let result = livedataObjectsInfo?.find(
                (liveobj) => data?.MACAddress == liveobj?.macaddress
            );
            data.Online = result?.online_status ? (
                <span className="green-dot ps-2 ms-4"></span>
            ) : (
                <span className="red-dot ps-2 ms-4"></span>
            );
            configured_devices_withstatus.push(data);
        }
        setDevicesList(configured_devices_withstatus);

    }
    const redirectionToSettings = (device) => {
        console.log(device)
        const { mac_address, device_uuid } = device.deviceObj;
        if (mac_address) {
            window.open(`/ipphoneadd?mac_address=${mac_address}`);
        } else {
            window.open(`/manualdevicesettings?device=${device_uuid}`);
        }
    };




    const actionData3 = {
        columns: [
            { label: "Phone Name", field: "phone_name" },
            { label: "User", field: "user" },
            { label: "Extension", field: "extension" },
            { label: "Designation", field: "designation" },
            { label: "Model", field: "model" },
            { label: "MAC Address", field: "mac_address" },
            { label: "Online", field: "online", sort: false },
        ],
        rows: devicesList.length > 0 ? devicesList : [],
    };


    const handleManualSearch = (searchValue) => {
        setsearchValue(searchValue);
        const filteredUsers = customSearch(devicesList, searchValue, UIConstant.LOCATION_DEVICES);

        setFilteredRows(filteredUsers);
    };


    return (
        <>
            <div className="locationUsersDatatble">
                <div class="actionbar"></div>
                <div className='mb-2 mt-2 position-relative w-auto'>
                    <MDBInput ref={searchRef} label="Search" value={searchValue}  onChange={(e) => handleManualSearch(e.target.value)} />
                    <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                </div>
                <MDBDatatable
                    sortField="Phone Name"
                    data = {{
                        ...actionData3,
                        rows : filteredRows
                    }}
                    key={searchValue}
                    entries={50}
                    className="mt-2 actioncolumn"
                    onRowClick={(data)=>redirectionToSettings(data)}
                />
            </div>
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
        </>
    )
}

export default LocDevices
